import { render, staticRenderFns } from "./CreateEditCoveragePlans.vue?vue&type=template&id=4fe17612"
import script from "./CreateEditCoveragePlans.vue?vue&type=script&lang=js"
export * from "./CreateEditCoveragePlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports